import last from "lodash/fp/last";
import apis from "../../core/apis.js";

class ReportResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.report).get(options);
  }

  get() {
    const args = arguments;
    const id = last(args);

    return this.$resource(apis.report + id).get();
  }

  post(item) {
    return this.$resource(apis.report).save(item);
  }

  captainRating(item) {
    return this.$resource(apis.report + "captain_rating").save(item);
  }

  generate(name, params) {
    return this.$resource(apis.report + name).save(params);
  }

  generateFinances(params) {
    return this.$resource(apis.report + "captain_finances").save(params);
  }
}

export default ReportResource;



// WEBPACK FOOTER //
// ./src/resources/report/report.resource.js